export function buildPixeCardShareUrl(postId: number, shareUrl?: string | null): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://pixeloop.com'
  const fallback = `${origin}/share/p/${postId}/`
  const raw = (shareUrl || '').trim() || fallback

  let url: URL
  try {
    url = new URL(raw, origin)
  } catch {
    url = new URL(fallback)
  }

  const postPath = url.pathname.match(/^\/p\/(\d+)(?:\/|$)/)
  if (postPath) {
    url.pathname = `/share/p/${postPath[1]}/`
  }

  const sharePath = url.pathname.match(/^\/share\/p\/(\d+)(?:\/|$)/)
  if (!sharePath) {
    url.pathname = `/share/p/${postId}/`
  }

  if (!url.searchParams.has('v')) {
    url.searchParams.set('v', '1')
  }

  return url.toString()
}
